/* eslint-disable @typescript-eslint/no-empty-function */
import { FormGroupState, KeyValue } from 'ngrx-forms';
import { NgxPermissionsService } from 'ngx-permissions';
import { Observable, of, takeUntil, withLatestFrom } from 'rxjs';

import { Component, Inject, OnInit } from '@angular/core';
import {
  ConfirmServiceInterface,
  LazyEntityFacadeInterface,
  PERMISSION_CREATE,
  PERMISSION_READ,
  RouterFacadeInterface,
  SharedEntityFacadeInterface,
} from '@ideapa/app-common';
import { BaseDto } from '@ideapa/common-dto';

import { BaseContainer } from './base.container';

@Component({
  standalone: false,
  template: '',
})
export abstract class BaseFormContainer<K extends KeyValue, T extends BaseDto>
  extends BaseContainer
  implements OnInit
{
  entity$ = this.facade.entity$;
  form$ = this.facade.form$;
  isNew$ = this.facade.isNew$;
  forceCanDeactivate = false;
  canDelete$ = this.facade.canDelete$;
  canSave$ = this.facade.canSave$;

  protected getCreatePermission = '';
  protected getUpdatePermission = '';

  constructor(
    @Inject('RouterFacade')
    protected routerFacade: RouterFacadeInterface,
    @Inject('FormFacade')
    protected facade: LazyEntityFacadeInterface<T, K>,
    @Inject('SharedEntityFacade')
    protected sharedFacade: SharedEntityFacadeInterface<T>,
    protected permissionsService: NgxPermissionsService,
    @Inject('ConfirmDialogService')
    protected confirmDialogService: ConfirmServiceInterface
  ) {
    super();
  }

  back() {
    this.facade.clearEntityId();
  }

  ngOnInit() {
    this.entity$
      .pipe(
        withLatestFrom(this.permissionsService.permissions$),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe(([entity, permissions]) => {});
  }

  canDeactivate(): Observable<boolean> {
    return of(true);
  }

  canViewEntity(entityName: string) {
    return !!(
      this.permissionsService.getPermission(
        `${PERMISSION_READ}_${entityName}`
      ) || this.permissionsService.getPermission(`${PERMISSION_READ}_all`)
    );
  }

  canAddEntity(entityName: string) {
    return !!(
      this.permissionsService.getPermission(
        `${PERMISSION_CREATE}_${entityName}`
      ) || this.permissionsService.getPermission(`${PERMISSION_CREATE}_all`)
    );
  }

  formSaveCallback(item: T) {}

  save(form: FormGroupState<K>) {
    this.facade.formSave(form);
  }

  async delete() {
    this.facade.formDelete();
  }
}
